import React, { Component } from "react";
import TriviaQuizUI from "./TriviaQuizUI";

export default class TriviaQuizPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      surveyId: null,
    };
  }
  componentDidMount() {
    const surveyId = this.props.match.params.surveyId;
    window.addEventListener('popstate', this.handlePopState);
    this.setState({ surveyId: surveyId });
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  }

  handlePopState = (e) => {
     e.preventDefault();
      window.history.forward();
  };


  render() {
    return (
      <div id="trivvy_quiz_page_xx">
        {this.state.surveyId && (
          <TriviaQuizUI surveyId={this.state.surveyId} {...this.props} />
        )}
      </div>
    );
  }
}
